export const sortDetails = ( toSortDetails, ids ) => {
    return toSortDetails.sort((a, b) => {
        const indexA = ids.indexOf(Number( a.id ))
        const indexB = ids.indexOf(Number( b.id ))

        return indexA - indexB
    })
}

export const isTimestamp = (n) => {
    const parsed = parseFloat(n)
    return !Number.isNaN(parsed) && Number.isFinite(parsed) && /^\d+\.?\d+$/.test(n)
}
  
export const getPrettyDate = ( unix, toShow = 'all', newDate = '', newDateMonth = '' ) => {
    let date = new Date( unix * 1000 );
    if( newDate )date = new Date( newDate );

    const formattedDate = date.toLocaleDateString('en-US', {
        year: 'numeric',
        month: newDateMonth ? newDateMonth.toString() : '2-digit',
        day: '2-digit'
    })
    const formattedTime = date.toLocaleTimeString('en-US', {
        hour: 'numeric',
        minute: '2-digit',
        hour12: true
    })

    if( toShow !== 'all' && toShow === 'date' ){
        return formattedDate
    }

    return `${formattedDate} ${formattedTime}`
}

export const formatDate = ( date ) => {
    const isObject = typeof date === 'object'

    if( !isObject ) return ''

    const day = date.day ?? ''
    const month = date.month ?? ''
    const year = date.year ?? ''

    const formatted = `${month}/${day}/${year}`

    return formatted 
}

export const formatMySqlDate = ( date ) => {
    const newDate = new Date( date )
    const formattedDate = `${newDate.getMonth() + 1}/${newDate.getDate()}/${newDate.getFullYear()}`

    return formattedDate
}

export const formatTgblDatePicker = ( date ) => {
    const newDate = new Date( date )
    const formattedDate = `${newDate.getFullYear()}-${newDate.getMonth() + 1}-${newDate.getDate()}`

    return formattedDate
}

export const getTgblFieldsDatePicker = ( newValue ) => {
    const formatDate = (dateStr) => {
        const date = new Date(dateStr)
        const options = { year: 'numeric', month: 'short', day: 'numeric' }
        return date.toLocaleDateString('en-US', options)
    }
    
      const startDate = formatDate(newValue.start)
      const endDate = formatDate(newValue.end)
    
      return `${startDate} - ${endDate}`
}

export const parseDate = ( dateString ) => {
    const [ month, day, year ] = dateString.split('/').map(Number)
    // Month is 0-indexed in JavaScript Date objects, so subtract 1 from the month
    return new Date(year, month - 1, day)
}

const getLastSeenTimeAgo = ( lastSeenTimestamp ) => {
    const currentTimestamp = Math.floor(Date.now() / 1000);
    const differenceSeconds = currentTimestamp - lastSeenTimestamp;

    if (differenceSeconds < 60) {
        // Less than a minute
        return `${differenceSeconds} seconds ago`;
    } else if (differenceSeconds < 3600) {
        // Less than an hour
        const minutesAgo = Math.floor(differenceSeconds / 60);
        return `${minutesAgo} minute${minutesAgo === 1 ? '' : 's'} ago`;
    } else if (differenceSeconds < 86400) {
        // Less than a day
        const hoursAgo = Math.floor(differenceSeconds / 3600);
        return `${hoursAgo} hour${hoursAgo === 1 ? '' : 's'} ago`;
    } else if( lastSeenTimestamp === 0 ){
        return '-'
    } else {
        // More than a day
        const daysAgo = Math.floor(differenceSeconds / 86400);
        return `${daysAgo} day${daysAgo === 1 ? '' : 's'} ago`;
    }
}

export const getLastActivity = ( selectedUser ) => {
    const allActivityTimestamps = []
    const lastActivityUnix = Number( selectedUser.lastActivityUnix ) ?? 0;
   
    allActivityTimestamps.push( lastActivityUnix )

    selectedUser.progress.forEach(progress => {
        if (progress.course_completed && progress.course_enrolled) {
            allActivityTimestamps.push( Number( progress.course_completed ) ?? 0 )
            allActivityTimestamps.push( Number( progress.course_enrolled ) ?? 0) 
        }
    })

    // Find the latest activity timestamp
    const latestActivityTimestamp = Math.max(...allActivityTimestamps)
    const lastSeen = getLastSeenTimeAgo( latestActivityTimestamp )
    return `${lastSeen !== '-' ? 'last seen' : ''} ${lastSeen}`
}

export const getLatestActivityCourse = ( usersData, courseId ) => {

    const allCoursesTimestamps = []

    const usersProgress = usersData
        .map(data => data['progress']) 
        .flat()
        .filter(course => course.course_id == courseId)

    usersProgress.forEach(progress => {
        if (progress.course_completed && progress.course_enrolled) {
            allCoursesTimestamps.push( Number( progress.course_completed ) ?? 0 )
            allCoursesTimestamps.push( Number( progress.course_enrolled ) ?? 0) 
            
        }
    })

    const latestActivityTimestamp = Math.max(...allCoursesTimestamps)

    return latestActivityTimestamp ?? 0
}

export const removeHtmlTags = ( input ) => {
    const htmlTagsRegex = /<[^>]+>/g
    let stringWithoutHtml = input.replace(htmlTagsRegex, '')

    stringWithoutHtml = stringWithoutHtml.trim()
    return stringWithoutHtml
}

export const sortQuestionCategories = ( data ) => {
    return data.sort((a, b) => {
        const cat_a = Number( a.category_id ?? 0 ) 
        const cat_b = Number( b.category_id ?? 0 ) 

        if (cat_a < cat_b) return -1
        if (cat_a > cat_b) return 1
        
        return 0;
    })
}

export const calculateQuizPoints = ( answerData, questions, questionCategory, toCalculate='sub-total' ) => {

    let overAllPoints = 0
    let answers = {}

    if( toCalculate === 'sub-total' ){
        const questionsToCalculate = Object.values( questions ).filter( val => val.category_id == questionCategory ) || {}
        const questionIds = questionsToCalculate.map( function( question ) {
            return question['id']
        })
        
        questionsToCalculate.forEach(function(question) {
            overAllPoints += Number( question.points ?? 0 ) 
        })

        answers = answerData.filter(answer => questionIds.includes( answer.question_id ) )
    }else {
        questions.forEach(function(question) {
            overAllPoints += Number( question.points ?? 0 ) 
        })
        answers = answerData
    }
  
    let [ correct, incorrect, hints, pointsScored ] = [ 0, 0, 0, 0 ]

    answers.map((answer) => {

        correct += Number( answer.correct_count ?? 0 )
        incorrect += Number( answer.incorrect_count ?? 0 )
        hints += Number( answer.hint_count ?? 0 )
        pointsScored += Number( answer.points ?? 0 )
    })
   
    return {
        points: overAllPoints,
        correct,
        incorrect,
        hints,
        pointsScored: pointsScored
    }
}

export const getPrettyUserMembershipStatus = ( status = '' ) => {
    if( status === '' ) return '';

    const removePrefix = status.replace('wcm-','')
    return removePrefix.charAt(0).toUpperCase()+ removePrefix.slice(1)
}

export const getLDGroupLabel = ( teamData ) => {
    const customLabels = teamData.group_options?.labels ?? { group:'Group', groups: 'Groups' }
    const groups = teamData.groups ?? []

    const singularLabel = customLabels.group || 'Group';
    const pluralLabel = customLabels.groups || 'Groups'

    return Object.keys( groups ) > 1 ? pluralLabel : singularLabel
}

export const getFileName = ( siteOption, teamName ) => {
    const updatedTeamName = teamName.trim().toLowerCase().replace(/\s+/g, '-')
    const updatedDate = siteOption.site_date.trim().toLowerCase().replace(/[\s,]+/g, (match) => (match.includes(' ') ? '-' : ''))

    return `${ siteOption.site_name}-${ updatedTeamName }-${ updatedDate }`
}
